import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpenses/mixins/ExpenseMixin.js'
import AutocompleteZ from '@/components/forms/AutocompleteZ'
import surveyForm from '@/views/private/Survey/surveyboard-form.js'
import Datepicker from 'vuejs-datepicker'

export default {
  mixins: [ActionsForm, ExpenseMixin],
  components: {
    AutocompleteZ,
    Datepicker
  },
  name: 'searchsurvey',
  props: ['datafilter'],
  data () {
    return {
      title: 'Pesquisar Supervisão',
      en: en,
      es: es,
      ptBR: ptBR,
      form: surveyForm,
      OptionStatusSurvey: [{
        id: 0,
        value: 'Não Enviado'
      },
      {
        id: 1,
        value: 'Aguardando Aprovação'
      },
      {
        id: 2,
        value: 'Aguardando Correção'
      },
      {
        id: 3,
        value: 'Aprovado'
      }
      ]
    }
  },
  methods: {
    clear () {
      this.form.dataInicioSolicitacao.value = ''
      this.form.statusVistoria.value = null
      this.$refs.TipoObraTypeahead.clear()
      this.$refs.responsavelTypeahead.clear()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/Survey/components/searchSurvey/searchSurvey.js